export enum EnumTipoParametro {
  Organizacion = 1,
  Presupuesto = 2,
  Usuario = 3
}
